export type AppLocale = "nl" | "en";

export function resolveEffectiveLocale(
  isAdminRoute: boolean,
  extranetLocale: AppLocale | undefined,
  override?: AppLocale | null,
): AppLocale {
  if (override) return override;
  if (isAdminRoute) return "nl";
  return extranetLocale ?? "nl";
}
